import { render, staticRenderFns } from "./subitem.vue?vue&type=template&id=ccee4e8e&scoped=true&"
import script from "./subitem.vue?vue&type=script&lang=js&"
export * from "./subitem.vue?vue&type=script&lang=js&"
import style0 from "./subitem.vue?vue&type=style&index=0&id=ccee4e8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccee4e8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ccee4e8e', component.options)
    } else {
      api.reload('ccee4e8e', component.options)
    }
    module.hot.accept("./subitem.vue?vue&type=template&id=ccee4e8e&scoped=true&", function () {
      api.rerender('ccee4e8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/components/menu/subitem.vue"
export default component.exports